// extracted by mini-css-extract-plugin
module.exports = {"center":"Loader_center__3ZBZ-","Loader":"Loader_Loader__3O-Ld","lds-roller":"Loader_lds-roller__bZoMR"};